import { render, staticRenderFns } from "./SecStudy_SKST.vue?vue&type=template&id=ad172f92&scoped=true&"
import script from "./SecStudy_SKST.vue?vue&type=script&lang=js&"
export * from "./SecStudy_SKST.vue?vue&type=script&lang=js&"
import style0 from "./SecStudy_SKST.vue?vue&type=style&index=0&id=ad172f92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad172f92",
  null
  
)

export default component.exports